var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCasinoGamesBlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5A5D64",
  d: "M18.182 1c-1 0-1.818.81-1.818 1.8 0 .63.363 1.26.909 1.53V14.5h-2.727v-1.8c.545 0 .909-.36.909-.9V3.7c0-.54-.364-.9-.91-.9h-3.454c-.727-1.08-2-1.8-3.364-1.8s-2.636.72-3.363 1.8H.909C.364 2.8 0 3.16 0 3.7v8.1c0 .54.364.9.91.9V19h13.636v-2.7h2.727c1 0 1.818-.81 1.818-1.8V4.33c.545-.27.909-.9.909-1.53 0-.99-.818-1.8-1.818-1.8m-7.273 15.3H4.545v-1.8h6.364zm2.727-5.4H1.818V4.6h11.818z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5A5D64",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3 6.424h2l-1.333 3m3.166-3.026h2l-1.333 3m3-2.974h2l-1.333 3"
})));
export default SvgCasinoGamesBlock;